import api from './api';

export const getContent = async (packageId: string) => {
  const response = await api.get(`/content?treatmentPackageId=${packageId}`, {
    authorizedRequest: false,
  });

  return response.data;
};
